<template>
	<div v-show="isModalVisible">
		<transition name="slide">
			<div class="modal-mask" @click="hide">
				<div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
					<div class="modal-content  p-2">
						<div class="modal-header">
							<a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
								<span aria-hidden="true">×</span>
							</button>          
						</div>                
                        
						<div class="modal-body">
							<div class="maheading_2">
								<h5 class="modal-title">Approve Mentee</h5>
							</div>  
							<div class="col-12 mt-3">
									<div class="row">
										<div class="col-12 p-0">
											<label
											for="email"
											class="col-12 p-0 bold">First Name:</label>
											{{ firstName }}            
										</div>
						
										<div class="col-12 p-0" style="margin-top: 10px;">     
											<label
											for="email"
											class="col-12 p-0 bold">Last Name:</label>
											{{ lastName }}            
										</div>
						
										<div class="col-12 p-0" style="margin-top: 10px;">
											<label
											for="email"
											class="col-12 p-0 bold">Email Address:</label>
											{{ email }}            
										</div>

										<div class="col-12 p-0" style="margin-top: 10px;">         
											<label
													for="phone_nno"
													class="col-12 p-0 bold">Phone Number:</label>
											<input
													type="phone_number"
													name="edit_phone_number"
													id="phone_number"
													class="col-12 col-sm-12 input-height-35 form-control"
													ref="phone_number"
													@keyup="adminPhoneValid($event)"
													@blur="adminPhoneValid($event)"
													v-validate="{ rules: { regex: adminPhoneRegex() } }"
													v-model="phoneNo"
													data-vv-as="Phone number"
													placeholder="Phone Number"
													maxlength="14">
											<div v-if="verrors.has('phone_number')" class="validate-warning-msg">The Phone Number is invalid</div>
										</div>
						

										<div class="col-12 p-0" style="margin-top: 10px;">
											<label
													for="hire_date"
													class="col-12 p-0 bold">Hire Date:</label>
											<div class="month-picker-elm-container">
												<month-picker-input 
													:default-month="hire_date_month"
													:default-year="hire_date_year"
													:clearable="false"
													:editable-year="false"
													:date-format="month_picker_date_format"
													input-class="col-12 col-sm-12 input-height-35 form-control"
													@input="input_hire_date"
													:max-date="input_max_date"
													>
												</month-picker-input>
												<i class="fa fa-calendar red-color" aria-hidden="true"></i>
												<div v-show="verrors.has('hire_date')" class="validate-warning-msg">{{ verrors.first('hire_date') }}</div>
											</div>
										</div>
					
										<div class="col-12 p-0" style="margin-top: 7px;">
											<label
													for="mentor"
													class="col-12 p-0 bold"> Assign Mentors: <span class="required">*</span></label>
											<div class="col-12 col-sm-12 tasklist-assign-wrapper"  v-for="(option, key, index) in groups">
												<div class="chkboxwrapper">
													<div class="custom-control custom-checkbox">
														<input 
														name="mentor_assigned"
														:value="option.id" 
														:id="'add_mentee_mentor_' + option.id" 
														type="checkbox" 
														v-model="mentor_assigned"
														v-validate="'required'"
														class="custom-control-input"
														> 
														<label class="custom-control-label" :for="'add_mentee_mentor_' + option.id">{{ option.groupName }}</label> 
													</div>
												</div>
											</div>
											<div v-if="verrors.has('mentor_assigned')" class="margin-bottom-5 validate-warning-msg">Mentor is required</div>
										</div> 

										<div class="col mt-4">
											<div class="row">
												<div class="col-6 p-0 submit margin-bottom-15" style="text-align: left;">
													<button :disabled="disable_add_mentee" type="submit" class="btn btn-info ma-blue-btn" @click="onSubmit('Approved')">Approve Mentee</button>
												</div>
												<div class="col-6 p-0 submit margin-bottom-15" style="text-align: right;">
													<button :disabled="disable_add_mentee" type="submit" class="btn btn-info ma-blue-btn" @click="onDenySubmit('Denied')" style="background-color: #FF0000 !important; border-color:  #FF0000 !important;">Delete Mentee</button>
												</div>
											</div>
										</div>
									</div>
							</div>

						</div>
						<div class="modal-footer mb-5"></div>
					</div>
				</div>
			</div>
		</transition>
    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import moment from 'moment';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { MonthPickerInput } from 'vue-month-picker';
import { handleMonthPickerYearNavButtons } from '@/components/shared/utils.js';


const today = new Date();
today.setHours(0, 0, 0, 0);

const todayMoment = moment();

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
Vue.use(MonthPickerInput);

export default {
    props: ['isModalVisible'],
    data() {
        return {
					loading: false,
					firstName: '',
					lastName: '',
					phoneNo: '',
					email: '',
					edit_mentor: '',
		      hire_date: '',
					month_picker_date_format: '%n, %Y',
					hire_date_month: todayMoment.month() + 1,
					hire_date_year: todayMoment.year(),
					input_max_date: todayMoment.toDate(),
					assignLicense: 0,
					menteeId: '',
		      successMessage: '',
					groups: [],
					mentor_assigned: [],
      		mentorSelected: [],
					menteeInviteId: '',
					disable_add_mentee: false,
        }
    },
    components: {
			DatePicker,
			MonthPickerInput,
    },
    methods: {       
        hide() { 
					this.$emit('close');
        },
				onSubmit(status) {
					this.$validator.validateAll().then((result) => {
						if(!result) {
							return;
						}
						this.updateMentee(status);
					})
					.catch(() => {

					});
				},
				onDenySubmit(status) {
					this.updateMentee(status);
				},
				updateMentee(status) {
					this.disable_add_mentee = true;
					if (!this.hire_date) {
						this.hire_date = todayMoment.format('YYYY-MM-01');
					}

					axios('/account-invitation-update-mentee',
					{
						method: 'POST',
						data: {
							"phone_number": this.phone_number,
							"hire_date": this.hire_date,
							"mentor": this.mentor_assigned,
							"account_id": this.$store.state.user_accountid,
							"menteeId": this.menteeId,
							"status": status,
							"menteeInviteId": this.menteeInviteId,
						}
					})
					.then(response => {
							this.disable_add_mentee = false;
							if (status == 'Approved') {
								this.successMessage = 'New Mentee Added Successfully!';
							}
							else {
								this.successMessage = 'Mentee deleted Successfully!';
							}
							
							setTimeout(() => {
								this.hide();
							}, 1000);               
					})
					.catch(error => {
							this.disable_add_mentee = false;
					});
				},

				adminPhoneRegex: function() {
					return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
				},
				notBeforeToday(date) {
					return date < today;
				},
				getMentorLists() {
					axios('/accountgroupsactive',
							{
								method: 'GET',
								params: {
									account_id: this.$store.state.user_accountid,
								}
							},
						)
						.then(response => {
							this.groups = response.data;        
						})
						.catch(error => {

						});
				}, 

				adminPhoneValid: function(event) {
					var phone_val = this.phoneNo;
					this.phoneNo = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
				},
				clearMonthPicker() {
					this.$emit('clear');
				},
				input_hire_date(data) {
					this.hire_date = data.year + '-' + (data.monthIndex < 10 ? '0' + data.monthIndex : data.monthIndex) + '-01';
				},
				getMentorDisplayText(count, name) {
					if (count == 1) {
							return name[0].text;
					} else {
							var num = (count - 1);
							if (count > 2) {
									var otherText = num + " Others";
							} else {
									var otherText = num + " Other";
							}
							return name[0].text + ", +" + otherText;
					}
				},
        loadInitialData(item) {
					this.menteeInviteId = item.menteeInviteId;
					this.menteeId = item.id;
					this.firstName = item.first_name;
					this.lastName = item.last_name;
					this.email = item.email;
					this.mentor_assigned = [];
					this.hire_date_month = todayMoment.month() + 1;
					this.hire_date_year = todayMoment.year();
					this.input_max_date = todayMoment.toDate();
					this.phoneNo = '';
					this.getMentorLists();
        },
    },
    created() {

    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}
.seat_qty {
    font-size: 13px;
}
.start-button-blue {
    color: #fff;
    background-color: #29A3E4;
    border: 1px solid #29A3E4;
    border-radius: 15px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 130px; 
}
.tasklist-assign-wrapper label {
  font-weight: normal;
}
.tasklist-assign-wrapper .chkboxwrapper {
  margin-bottom: 5px;
}
.mx-datepicker {
  width: 100%;
}
.signin-form input {
  border: 1px solid #ced4da;
}
.content-main-wrapper {
  width: 90% !important;
  background-color: #FFF !important;
  padding: 25px;
}
input {
  line-height: 17px;
  border-radius: 10px;
  padding-left: 5px !important;
  border: 1px solid #707070;
}
.add-form-heading {
  font-size: 18px;
  font-weight: bold;    
}
.add-form-wrapper {
  margin: 0px 10px 0px 30px; 
}
.add-mentee-form label.bold{
  font-weight: 600;
  padding-left: 0px;
}
/deep/ .month-picker-input-container {
  width: 100% !important;
}
/deep/ .month-picker-input {
  width: 100%;
}
/deep/ .month-picker__container {
  z-index: 9999;
  width: 100% !important;
}
.month-picker-elm-container {
  position: relative;
}
.month-picker-elm-container .fa-calendar {
  position: absolute;
  top: 35%;
  right: 5%;
  pointer-events: none;
  color: #00ACEE;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #808080;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #FFF;
}

input:checked + .slider {
  background-color: #4E8D23;
}
input:checked + .slider:before {
  background-color: #FFF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

</style>

<style>
.month-picker-input {
  line-height: 17px;
  border-radius: 10px !important;
  display: block;
  width: 100% !important;
  padding-top: 0.575rem !important;
  padding-bottom: 0.575rem !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  border: 1px solid #707070 !important;
  font-size: 1rem !important;
  font-weight: 400;
}    
@-moz-document url-prefix() {
  .month-picker-input {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }  
}

</style>


// WEBPACK FOOTER //
// src/components/manager/update_account_invitation_mentee.vue